import styled from 'styled-components';

export const CookieTitleSt = styled.h6<any>`
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral800};
`;
